 <form class="wrapper" [formGroup]="form">

   <div class="inputs-wrapper">
     <div class="input-wrapper">
       <input #id formControlName="id" [placeholder]="getUserTypeTitle(this.authService.UserType) + ' ID'">
       <span class="asterisk error-msg" *ngIf="form.get('id').touched && form.get('id').hasError('required')">Please enter {{getUserTypeTitle(this.authService.UserType)}} ID</span>
       <span class="asterisk error-msg" *ngIf="form.get('id').touched && !form.get('id').hasError('required') && form.get('id').hasError('pattern')">Only numbers allowed</span>

     </div>

     <div class="input-wrapper">
       <input formControlName="pin" [placeholder]="'PIN'">
       <span class="asterisk error-msg" *ngIf="form.get('pin').touched && form.get('pin').hasError('required')">Please enter PIN</span>
     </div>
   </div>
     <div class="actions-wrapper">
       <button (click)="submit()" class="button-1">{{'SAVE' | dictionary}}</button>
       <button (click)="cancel()" class="ml-15  button-1">{{'CANCEL' | dictionary}}</button>
     </div>
 </form>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onClosePopup()">
 </app-pop-up-dialog>



